var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgResources = function SvgResources(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 44,
    viewBox: "0 0 35 44",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-83 -347)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M84.458 348.458h32.084v5.834H84.458zm32.084 27.709h-6.563a.73.73 0 0 0-.729.729v6.562H84.458V355.75h32.084zm-5.834 6.26v-4.802h4.803zm5.834 3.938H84.458v-1.456h25.521a.733.733 0 0 0 .516-.214l6.047-6.039zm-32.084 1.468h32.084v1.459H84.458zM118 347.73a.73.73 0 0 0-.73-.729H83.73a.73.73 0 0 0-.73.73v42.29c0 .404.326.73.73.73h33.54a.73.73 0 0 0 .73-.73z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M88.83 378.358h18.23V376.9H88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M88.83 369.608h7.292v-1.458H88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M97.58 369.608h14.583v-1.458H97.58z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M103.42 373.978h8.75v-1.458h-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M88.83 373.978h13.125v-1.458H88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M88.83 365.228h13.125v-1.458H88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M103.42 365.228h8.75v-1.458h-8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M88.83 360.858h4.375V359.4H88.83z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M94.67 360.858h2.917V359.4H94.67z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgResources, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/resources.02a79005.svg";
export { ForwardRef as ReactComponent };